export const UPLOAD_FILE = 'sagas/files/UPLOAD_FILES';
export const UPLOAD_INFO = 'sagas/files/UPLOAD_INFO';
export const UPLOAD = 'sagas/files/UPLOAD';
export const GET_FILES_CAUSE = 'sagas/files/GET_FILES_CAUSE';
export const UPLOAD_BY_URL = 'sagas/files/UPLOAD_BY_URL';
export const UPDATE_FILE = 'sagas/files/UPDATE_FILES';
export const UPDATE_BY_URL = 'sagas/files/UPDATE_BY_URL';